import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableJobs } from "./components/JobsTable/TableJobs";
import { Job } from "./models/Job";
import { getJobs } from "./repositories/JobsRepository";

export const searchJobs = () => {
	return useQuery<Job[], Error>({
		queryKey: ["jobs"],
		queryFn: ({ signal }) => getJobs(signal),
	});
};

export const Jobs = () => {
	return (
		<>
			<HelmetDexteel title="System Jobs" />
			<TableJobs />
		</>
	);
};
